import React,{ Component } from 'react';
import './_sidebar.css';
import SearchField from './SearchField';
import Info from '../Info';
import Avatar from '../Avatar';
import ContatosActions, { getContactsFilter } from '../../redux/contatoStore';
import { connect } from 'react-redux';
import { debounce } from 'lodash/fp';

const icons = {
    chat : require('../../img/icons/chat-white.png'),
    people : require('../../img/icons/people-blue.png'),
    people_white: require('../../img/icons/people-white.png'),
    chat_blue: require('../../img/icons/chat-blue.png'),
    bell : require('../../img/icons/bell-blue.png'),
    logo : require('../../img/icons/logo.png'),
}

const avatar = require('../../img/icons/avatar.png');

class Sidebarinfo extends Component{

    constructor(props){
        super(props);
        this.state = {
            nameUser: ''
        };

        this.getContacts = debounce(600, props.getContacts);
    }

    componentDidMount(){
        this.validateNameUser()
    }

    validateNameUser(){
        let { nome } = this.props.user
        let name
        let isValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if(isValid.test(nome)){

            const validate = new RegExp('([-+_+.+@+]+)');
            name = nome.split(validate)
            this.setState({ nameUser: name[0] })
            
        } else {
            name = nome.split(" ");
            this.setState({ nameUser: name[0] })
        }
    }

    onChangeSearch = event => {
        const { user } = this.props;
        const search = event.target.value;
        this.getContacts(user.licenca, search);
        this.props.setContactsFilter(search);
    }

    render(){
        const { nameUser } = this.state

        const { changeImg, contactsFilter } = this.props
        return(
            <div className="sidebar-info-container">
                <div className="sidebar-info sidebar-info-title"> 
                    <div>
                        <img id="logo" src={icons['logo']} alt=""/>    
                    </div>
                </div>
                <div className="sidebar-info sidebar-info-user">
                    <div className="user-avatar" style={{width: 142, display: 'inherit',}}>
                        <Avatar src={avatar} size={35} />
                        <Info 
                            style={{paddingLeft: 5, paddingRight: 5}}
                            titleStyle={{color: '#fff'}}
                            subtitleStyle={{color: '#fff'}}
                            title={nameUser || "Atendente"}
                            subtitle="Imobiliária"
                        />
                    </div>
                    <div className="info-user-acoes">
                        <div onClick={() => this.props.onClickMessageCallback() } className="icons-info-users">
                            <img src={icons[ changeImg ? 'chat_blue' : 'chat']} alt=""/>
                            <span className="title-info-user">Conversas</span>
                        </div>
                        <div onClick={() => this.props.onClickContactCallback()} className="icons-info-users">
                            <img src={icons[changeImg ? 'people_white' : 'people']} alt=""/>
                            <span className="title-info-user">Contatos</span>
                        </div>
                    </div>
                </div>
                <SearchField
                    value={contactsFilter}
                    onChange={this.onChangeSearch} 
                    onFocus={() => this.props.onClickContactCallback()} />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    contactsFilter: getContactsFilter(state)
});

const mapDispatchToProps = {
    getContacts: ContatosActions.getContacts,
    setContactsFilter: ContatosActions.setContactsFilter
};


Sidebarinfo.defaultProps = {
    user : {}
}
export default connect(mapStateToProps, mapDispatchToProps)(Sidebarinfo);


// WEBPACK FOOTER //
// ./src/components/sidebar/SidebarInfo.js